module.exports = __webpack_public_path__ + "img/Icon_Key.3cce1968.svg";